import { useIntl } from '@/intl'
import { space, tok } from '@sunwebgroup/ui-components'
import { Tag, Typography } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'

const UserRatingWrapper = styled.div`
  color: ${tok('primitives_color_green_550')};
  ${Tag} {
    margin-right: ${space('primitives_space_8')};
    background-color: ${tok('primitives_color_green_50')};
    color: ${tok('primitives_color_green_550')};
  }
`

export function UserRating({ userRating }: { userRating: number | undefined }) {
  const intl = useIntl()
  const getUserRating = (userScore: number) => {
    if (userScore >= 8) {
      return intl.formatMessage({
        id: 'product_card_user_rating_fantastic',
      })
    }
    else if (userScore >= 6) {
      return intl.formatMessage({
        id: 'product_card_user_rating_good',
      })
    }
    else if (userScore >= 4) {
      return intl.formatMessage({
        id: 'product_card_user_rating_average',
      })
    }
    else if (userScore >= 2) {
      return intl.formatMessage({
        id: 'product_card_user_rating_reasonable',
      })
    }

    return intl.formatMessage({
      id: 'product_card_user_rating_unsatisfied',
    })
  }

  if (userRating === undefined || userRating <= 0) {
    return null
  }

  return (
    <UserRatingWrapper>
      <Tag>{userRating}</Tag>
      <Typography $variant="body-m-bold-tight">{getUserRating(userRating)}</Typography>
    </UserRatingWrapper>
  )
}
